"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useSyncExternalStore } from "react";
import { getPromoSuppression } from "@/lib/emailPromoSuppression";
import { selectPromoModal } from "@/lib/promoModal/selectPromoModal";
import type { PromoModal } from "@/lib/promoModal/types";
import { EmailPromoModalClient } from "./EmailPromoModalClient";
interface Props {
  modals: PromoModal[];
  pathname: string;
  isPreview: boolean;
}
const isGlobal = (modal: PromoModal) => !modal.pagePaths?.length;
const subscribe = () => () => {};

/** Picks the single campaign for this page. Storage is client-only, so the server renders nothing. */
export function PagePromoModal(t0) {
  const $ = _c(17);
  const {
    modals,
    pathname,
    isPreview
  } = t0;
  const [shownId, setShownId] = useState(null);
  let t1;
  if ($[0] !== isPreview || $[1] !== modals || $[2] !== pathname) {
    t1 = () => selectPromoModal(modals, pathname, modal => getPromoSuppression({
      id: modal.id,
      isGlobal: isGlobal(modal)
    }, isPreview) !== null)?.id ?? null;
    $[0] = isPreview;
    $[1] = modals;
    $[2] = pathname;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const selectedId = useSyncExternalStore(subscribe, t1, _temp);
  let t2;
  if ($[4] !== modals || $[5] !== selectedId || $[6] !== shownId) {
    let t3;
    if ($[8] !== selectedId || $[9] !== shownId) {
      t3 = candidate => candidate.id === (shownId ?? selectedId);
      $[8] = selectedId;
      $[9] = shownId;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = modals.find(t3);
    $[4] = modals;
    $[5] = selectedId;
    $[6] = shownId;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const modal_0 = t2;
  if (!modal_0) {
    return null;
  }
  let t3;
  if ($[11] !== modal_0.id) {
    t3 = () => setShownId(modal_0.id);
    $[11] = modal_0.id;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== isPreview || $[14] !== modal_0 || $[15] !== t3) {
    t4 = <EmailPromoModalClient key={modal_0.id} modal={modal_0} onShow={t3} isPreview={isPreview} />;
    $[13] = isPreview;
    $[14] = modal_0;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}
function _temp() {
  return null;
}